import { Form, message, Select } from 'antd'
import SettingsCard from 'egi/app/Settings/components/SettignsCard/SettingsCard'
import React, { useEffect, useState } from 'react'
import { IPartnerDetail, PartnerService, partnerServices, PartnerUpdateBody } from '../partnerApiCredentials'

interface IProps {
  promoter: IPartnerDetail
  onSave: (body: PartnerUpdateBody) => Promise<void>
}

export default function ServicesSection ({ promoter, onSave }: IProps) {
  const [form] = Form.useForm<{ services: PartnerService[] }>()
  const [saving, setSaving] = useState(false)

  const servicesKey = JSON.stringify(promoter.services)

  useEffect(() => {
    form.setFieldsValue({ services: servicesKey ? JSON.parse(servicesKey) : [] })
  }, [form, servicesKey])

  const save = async ({ services }: { services: PartnerService[] }) => {
    setSaving(true)
    try {
      await onSave({ services })
    } catch (err) {
      message.error(err.message)
    } finally {
      setSaving(false)
    }
  }

  return (
    <SettingsCard className="mb-2">
      <SettingsCard.title>Serviços liberados</SettingsCard.title>
      <SettingsCard.description>Marque os serviços que este parceiro pode chamar.</SettingsCard.description>

      <Form form={form} layout="vertical" className="mt-3" onFinish={save}>
        <Form.Item
          name="services"
          label="Serviços"
          extra={`Selecione os serviços que o parceiro pode chamar. Opções: ${partnerServices.map(service => service.value).join(', ')}.`}
        >
          <Select
            mode="multiple"
            placeholder="Selecione os serviços"
            options={partnerServices}
            optionFilterProp="label"
          />
        </Form.Item>

        <SettingsCard.ButtonsContainer>
          <SettingsCard.submitButton loading={saving}>Salvar</SettingsCard.submitButton>
        </SettingsCard.ButtonsContainer>
      </Form>
    </SettingsCard>
  )
}
